/* ───────────────────────────────────────────
   About – Qui som + mapa + servicios
   ─────────────────────────────────────────── */
import React from "react";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ClusterMap from "@/components/ClusterMap";
import { centres } from "@/data/centres";
import { styles } from "@/styles";
import { servicios } from "@/constants";
import { SectionWrapper } from "@/hoc";
import { fadeIn, textVariant } from "@/utils/motion";
import "leaflet/dist/leaflet.css";

const CardGlow = ({ children }) => (
  <div className="ls-card inline-flex flex-col items-center gap-4 px-8 py-10">
    {children}
  </div>
);

const ServiceCard = ({ index, title, icon, link }) => {
  const { t } = useTranslation();
  return (
    <Tilt className="w-[220px] flex-shrink-0">
      <motion.div
        variants={fadeIn("right", "spring", index * 0.35, 0.75)}
        className="w-full"
      >
        <Link to={link}>
          <CardGlow>
            <img src={icon} alt={title} className="w-16 h-16 object-contain" />
            <h3 className="text-[18px] font-semibold text-black text-center whitespace-nowrap">
              {t(title, title)}
            </h3>
          </CardGlow>
        </Link>
      </motion.div>
    </Tilt>
  );
};

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-about-pattern bg-cover bg-center relative">
      <div className="about-card relative z-10 mx-auto mt-24">
        <motion.h2
          variants={textVariant()}
          className={`${styles.sectionHeadText} text-center text-white`}
        >
          {t("about.titleMap")}
        </motion.h2>

        <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className={`${styles.bodyText} text-white text-center mt-10 max-w-4xl mx-auto`}
        >
          {t("about.mapDescription")}
        </motion.p>

        <div className="mt-16 rounded overflow-hidden shadow-xl ring-1 ring-white/20">
          <ClusterMap locations={centres} zoom={8} height="60vh" />
        </div>

        <div className="mt-24 flex justify-center gap-8 overflow-x-auto px-4 noscrollbar">
          {servicios.map((s, i) => (
            <ServiceCard key={s.title} index={i} {...s} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionWrapper(About, "about");
